export default __webpack_public_path__ + "static/media/bannerCTA.4869b0aa.png";